import React from 'react';

const Tag = ({ w, h, color = 'black', ...props }) => {
  return (
    <svg
      width={h}
      height={h}
      {...props}
      version="1.2"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="m24.5 0.1h431l6 2.8c3.4 1.6 7.7 4.8 9.9 7.3 2.2 2.3 4.9 6.3 6 8.8 2.1 4.4 2.1 5.9 2.6 213l-7.3-5.3c-3.9-2.9-10.1-7.1-13.7-9.2-3.6-2.1-7.5-4.4-11-6.5v-115h-416v352h179.5l1.8 3.7c1.1 2.1 4.7 8.1 8.2 13.3 3.5 5.2 7.3 10.7 10.5 15h-232l0.2-228.3c0.3-228.1 0.3-228.2 2.4-232.7 1.1-2.5 3.8-6.5 6-8.8 2.1-2.5 6.6-5.7 9.9-7.3zm167.5 128h224v96l-31.5 0.2 11 2.2c6 1.3 14.6 3.6 19 5.1 4.4 1.5 12 4.8 17 7.2 4.9 2.5 12.8 7 17.5 10.1 4.7 3.1 12.7 9.7 17.9 14.7 5.2 4.9 11.9 12.4 15 16.5 3.1 4.1 6.8 9.3 8.2 11.5 1.5 2.2 4.4 7.6 6.6 12 2.3 4.4 5.5 12 7.2 17 1.8 4.9 4.3 14.5 5.7 21.2 1.8 9.5 2.4 15.4 2.4 26.3 0 10.8-0.6 16.7-2.4 26.2-1.4 6.8-3.9 16.3-5.7 21.3-1.7 4.9-4.8 12.4-6.9 16.5-2.1 4.1-6.6 11.8-10.1 17-3.9 5.8-10.5 13.7-17.3 20.5-6.9 6.9-14.7 13.5-20.6 17.4-5.2 3.5-12.9 8-17 10.1-4.1 2.1-11.6 5.2-16.5 6.9-5 1.8-14.5 4.3-21.2 5.6-9.5 1.9-15.5 2.5-26 2.5-9.8 0-17-0.6-24.8-2.1-6.1-1.2-15.7-3.7-21.5-5.6-5.8-2-13.9-5.2-18-7.3-4.1-2.1-11.8-6.6-17-10.1-5.8-3.9-13.8-10.6-20.5-17.4-6.8-6.7-13.5-14.7-17.4-20.5-3.5-5.2-8-12.9-10.1-17-2.1-4.1-5.2-11.6-6.9-16.5-1.8-5-4.2-13.5-5.3-19-1.8-8.2-2.2-13.4-2.2-28.5-0.1-15.9 0.3-20 2.3-29 1.3-5.8 3.7-14.3 5.3-19 1.7-4.7 4.8-12.1 7-16.5 2.3-4.4 6.6-11.8 9.7-16.4 3.1-4.7 9.6-12.7 14.6-17.9 4.9-5.3 12.4-12.1 16.5-15.2 4.1-3.1 9.8-7 12.5-8.8 2.8-1.7 9.3-5.1 14.5-7.6 5.2-2.4 12.4-5.4 16-6.6 3.6-1.2 11.4-3.3 28.5-6.8l-159.5-0.2zm32 64h160v-32h-160zm128 160h-64v32h64v64h32v-64h64v-32h-64v-64h-32zm-288-192h96v32h-96zm0 160h96v32h-96z"
      />
    </svg>
  );
};

export default Tag;
